export const naturalSort = (a, b, desc = false) => {
  const isNumeric = !isNaN(a) && !isNaN(b);
  if (desc) {
    return `${b}`.localeCompare(`${a}`, 'en', {numeric: isNumeric});
  } else {
    return `${a}`.localeCompare(`${b}`, 'en', {numeric: isNumeric});
  }
}
